import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import secureLocalStorage from 'react-secure-storage'
import { MyContext } from '../../Context/MyProvider';
import ImageLoad from '../ImageLoad';
import { useNavigate, useParams } from 'react-router-dom';
import Btn_loader from '../Btn_loader';
import BookApoint from './BookApoint';
import { motion } from 'framer-motion';
import PageLoading from '../PageLoading';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import ImagePrev from '../ImagePrev';
import { useTranslation } from 'react-i18next';
import { 
    Bell, 
    Check, 
    Compass, 
    Globe, 
    GraduationCap, 
    Music, 
    Play, 
    Pause, 
    Lock, 
    Plus, 
    X, 
    Heart, 
    MessageCircle, 
    Phone, 
    Video,
    Star,
    Activity,
    HelpCircle,
    Image as ImageIcon
} from 'lucide-react';

const Astrologers_details = () => {
    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi, setIsToast, setToastMsg, paymentRes, setPaymentRes, formatPrice } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [userdata, setUserData] = useState("");
    const [generaldetail, setGeneralDetail] = useState("");
    const [showmore, setShowMore] = useState(false);
    const [isfollow, setISFollow] = useState(0);
    const [reviewslist, setReviewsList] = useState([]);
    const [postlist, setPostList] = useState([]);
    const [apiloading, setApiLoading] = useState("");
    const [kundlilist, setKundliList] = useState([]);
    const [ischatpaymodel, setIsChatPayModel] = useState(false);
    const [isclickindex, setIsClickIndex] = useState(0);
    const [iscommentmodel, setIsCommentModel] = useState(false);
    const [commentlist, setCoomentList] = useState([]);
    const [inputcomment, setInputComment] = useState("");
    const [commentdata, setCommentData] = useState("");
    const [deletecomid, setDeleteComId] = useState("");
    const [isstep, setIsStep] = useState(1);
    const [userwallet, setUserWallet] = useState("");
    const [faqList, setFaqList] = useState([]);
    const [playing, setPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [showAudioPlay, setShowAudioPlay] = useState(false);
    const [wevaList, setWevaList] = useState("");
    const [isSubscribe, setIsSubscribe] = useState(false);
    const [giftList, setGiftList] = useState([]);
    const [selectGift, setSelectGift] = useState([]);
    const [showModel, setShowModel] = useState("");
    const [imgList, setImgList] = useState("");
    const [imgIndex, setImgIndex] = useState(0);

    const WeveLength = 20;
    const audioRef = useRef(null);
    const HomeRef = useRef(false);
    const GiftRef = useRef(false);

    const navigate = useNavigate();
    const perams = useParams();
    const astrologer_id = perams.id;

    const Currency = secureLocalStorage.getItem("currency") || "$";
    const Userid = secureLocalStorage.getItem("Userid");

    const sampleReview = {
        name: "Rohan Joshi",
        tot_star: 4.5,
        review: "Excellent guidance and very empathetic behavior. They took time to understand my birth details and walked me through my Sade Sati period step-by-step, explaining how to navigate it positively. I feel much more calm and prepared now.",
        profile: ""
    };

    const samplePosts = [
        {
            id: "sample-post-1",
            name: "Acharya Shastri",
            pimage: "",
            date: "8d",
            text: "Full Moon in Scorpio illumination: A powerful time for emotional healing, transformation, and releasing what no longer serves your spiritual path. Embrace the shift.",
            tlikes: 6,
            tcomments: 0,
            media: [],
            IsLike: 0,
            astro_id: astrologer_id
        },
        {
            id: "sample-post-2",
            name: "Acharya Shastri",
            pimage: "",
            date: "13d",
            text: "Mercury retrograde begins tomorrow. It's time to review, reflect, and reboot. Avoid signing major contracts or buying new communication devices if possible. Double-check all plans.",
            tlikes: 3,
            tcomments: 0,
            media: [],
            IsLike: 0,
            astro_id: astrologer_id
        },
        {
            id: "sample-post-3",
            name: "Acharya Shastri",
            pimage: "",
            date: "18d",
            text: "The alignment of Jupiter and Saturn this week brings incredible opportunities for professional growth. Focus on long-term strategy and trust your intuition.",
            tlikes: 5,
            tcomments: 2,
            media: [],
            IsLike: 0,
            astro_id: astrologer_id
        }
    ];

    const sampleFaqs = [
        {
            id: "sample-faq-1",
            title: "What information is required for an accurate Kundali?",
            description: "To prepare an accurate Janam Kundali (natal chart), I require your precise date of birth, exact time of birth (including AM/PM), and city of birth. This allows me to calculate the exact planetary positions at the moment of your birth."
        },
        {
            id: "sample-faq-2",
            title: "How does Kundali matching help in marriages?",
            description: "Kundali matching (Gun Milan) compares 8 categories (Ashtakoota) of the couple's birth charts. It assesses compatibility across mental waves, temperament, mutual respect, progeny, and health, ensuring a harmonious lifetime bond."
        },
        {
            id: "sample-faq-3",
            title: "Can astrology predict my career and financial changes?",
            description: "Yes. By analyzing the 2nd (wealth), 6th (service), 10th (career), and 11th (gains) houses, along with active planetary periods (Dashas) and transits, astrology can indicate ideal career fields, promotion cycles, or financial growth phases."
        },
        {
            id: "sample-faq-4",
            title: "What are the common remedies suggested?",
            description: "Astrological remedies are designed to balance planetary energies. They include wearing specific natural gemstones, chanting powerful planetary mantras regularly, observing fasts on specific days, and performing acts of charity."
        },
        {
            id: "sample-faq-5",
            title: "What is Sade Sati, and is it always negative?",
            description: "Sade Sati is Saturn's 7.5-year transit over your natal Moon. While it represents a period of hard work, discipline, and testing, it is not purely negative. It is a period of immense learning, maturity, and long-term success."
        }
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
        handleFethData(Userid || "0");
        if (Userid) {
            handleGetGiftList()
        }
        const wevaHeight = Array.from({ length: WeveLength }).map(() => handleGetWevaHight());
        setWevaList(wevaHeight);
    }, []);

    useEffect(() => {
        window.document.body.style.overflow = iscommentmodel ? "hidden" : "auto";
    }, [iscommentmodel]);

    const totalPrice = useMemo(() => {
        return selectGift.reduce((sum, gift) => sum + gift.price, 0);
    }, [selectGift]);

    useEffect(() => {
        if (!paymentRes) return;

        if (paymentRes === "PaymentDone") {
            setIsChatPayModel(true);
        } else {
            setIsToast(true);
            setToastMsg("Payment faild !!");
            setPaymentRes("");
        }
    }, [paymentRes]);

    const handleFethData = async (id) => {
        if (HomeRef.current) return;
        HomeRef.current = true;

        const Response = await HandleCallApi("Post", "user/astrologer_detail", { id, astrologer_id });
        if (!Response || !Response.data) {
            setLoading(false);
            return;
        }
        const { astrologer_detail, general_detail, review_list, post_list, user_wallet, astro_faqs, subscribe } = Response.data;

        if (!astrologer_detail || !astrologer_detail.id) {
            navigate("*");
            return;
        }

        setUserData(astrologer_detail);
        setISFollow(astrologer_detail?.is_followed);
        setGeneralDetail(general_detail);
        secureLocalStorage.setItem("default_image", general_detail?.default_image || "uploads/settings/1772771577662default_pic.png");
        
        // Merge API reviews and sample review
        const combinedReviews = [...(review_list || []), sampleReview];
        setReviewsList(combinedReviews);
        
        setUserWallet(user_wallet);
        
        // Merge API faqs and sample faqs
        const combinedFaqs = [...(astro_faqs || []), ...sampleFaqs];
        setFaqList(combinedFaqs);
        
        setIsSubscribe(subscribe);
        setIsStep(1); // Default to Reviews Tab active

        setTimeout(() => {
            setLoading(false);
        }, 500);

        const apiPosts = post_list || [];
        const LocalLikeData = secureLocalStorage.getItem("Likedata");
        let initialPosts = [...apiPosts, ...samplePosts];

        if (LocalLikeData && LocalLikeData !== "null" && LocalLikeData !== "undefined") {
            try {
                const jsonData = typeof LocalLikeData === 'string' ? JSON.parse(LocalLikeData) : LocalLikeData;
                if (jsonData && Array.isArray(jsonData)) {
                    const user = jsonData.find(u => u.id == id);
                    if (user) {
                        const astro = user.data.find(a => a.astrologer_id == astrologer_id);
                        if (astro) {
                            const likedIds = astro.likeids || [];
                            initialPosts = initialPosts.map(item => {
                                if (likedIds.includes(item.id)) {
                                    return {
                                        ...item,
                                        islike: 1,
                                        IsLike: 1
                                    };
                                }
                                return item;
                            });
                        }
                    }
                }
            } catch (e) {
                console.error("Error processing Likedata in Astrologers_details:", e);
            }
        }
        setPostList(initialPosts);
    }

    const handleGetGiftList = async () => {
        if (GiftRef.current) return;
        GiftRef.current = true;
        const Response = await HandleCallApi("Get", "user/gift_list");
        if (Response && Response.data) {
            setGiftList(Response.data.gift_list);
        }
    }

    const handleFollow = async () => {
        if (!Userid) {
            navigate("/auth/login");
            return;
        }
        setApiLoading("follow");
        const Response = await HandleCallApi("Post", "user/add_remove_astro_follower", { id: Userid, astrologer_id: userdata?.id });
        if (Response && Response.data) {
            const { ResponseCode, message } = Response.data;
            setIsToast(true);
            setToastMsg(message);
            if (ResponseCode === 200) {
                setISFollow(isfollow === 1 ? 0 : 1);
            }
        }
        setApiLoading("");
    }

    const handleStartChat = async (textloading, index) => {
        if (!Userid) {
            navigate("/auth/login");
            return;
        }
        if (generaldetail?.old_appointmnet_status == 0 || generaldetail?.old_appointmnet_status == 4 || generaldetail?.old_appointmnet_status == 5) {
            if (apiloading) return;
            setIsClickIndex(index);
            if (Userid) {
                setApiLoading(textloading);
                const Response = await HandleCallApi("Post", "user/user_kundli_list", { id: Userid });
                if (Response && Response.data) {
                    setKundliList(Response.data.kundli_list);
                    setIsChatPayModel(true);
                }
                setApiLoading("");
            }
        } else {
            setIsToast(true);
            setToastMsg("Please Complete Last Apointment !!");
        }
    }

    const handleGetComment = async (item, status) => {
        if (!Userid) {
            navigate("/auth/login");
            return;
        }

        setIsCommentModel(true);
        setDeleteComId("");
        setCommentData(item);

        if (item.id.toString().startsWith("sample")) {
            // Mock sample comment storage locally or empty list
            // Check if we already simulated comments for this sample post
            return;
        }

        const ApiData = {
            id: Userid,
            astrologer_id: item.astro_id,
            post_id: item.id,
            comment: inputcomment || "",
            comment_id: deletecomid || "",
            status
        }

        if (status === "0") {
            setApiLoading("Comment");
        }
        const Response = await HandleCallApi("Post", "user/add_remove_comment_list", ApiData);
        if (Response && Response.data) {
            setCoomentList(Response.data.comment_list);
        }
        setApiLoading("");
        setInputComment("");
    }

    const handleSendComment = () => {
        if (!inputcomment) {
            setIsToast(true);
            setToastMsg("Please enter comment !!");
            return;
        }

        if (commentdata.id.toString().startsWith("sample")) {
            const newComment = {
                id: Date.now().toString(),
                name: "You",
                profile: "",
                date: "0s",
                mes: inputcomment,
                uid: Userid
            };
            setCoomentList(prev => [...prev, newComment]);
            setInputComment("");

            const FilterPost = postlist.map(p => {
                if (p.id === commentdata.id) {
                    return { ...p, tcomments: p.tcomments + 1 };
                }
                return p;
            });
            setPostList(FilterPost);
            return;
        }

        handleGetComment(commentdata, "1");
    }

    const handleDeleteSampleComment = (commentId) => {
        setCoomentList(prev => prev.filter(c => c.id !== commentId));
        const FilterPost = postlist.map(p => {
            if (p.id === commentdata.id) {
                return { ...p, tcomments: Math.max(0, p.tcomments - 1) };
            }
            return p;
        });
        setPostList(FilterPost);
        setDeleteComId("");
    }

    const handleLikePost = async (item, isliked) => {
        if (!Userid) {
            navigate("/auth/login");
            return;
        }

        if (item.id.toString().startsWith("sample")) {
            // Local simulation toggling like
            HandleFilterPost(item, isliked);
            return;
        }

        const Response = await HandleCallApi("Post", "user/add_remove_like", { id: Userid, astrologer_id: item.astro_id, post_id: item.id });
        setIsToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            HandleFilterPost(item, isliked);
        }
    }

    const HandleFilterPost = (data, isliked) => {
        const FilterPost = postlist.map(item => {
            if (item.id === data.id) {
                const IsLike = isliked == 1 ? 0 : 1;
                const tlikes = isliked == 1 ? item.tlikes - 1 : item.tlikes + 1;
                return { ...item, IsLike, tlikes };
            }
            return item;
        });
        setPostList(FilterPost);
    }

    const handlePlayAudio = () => {
        if (!playing) {
            audioRef.current.play().catch(error => {
                console.log("Audio play interrupted/prevented:", error);
            });
        } else {
            audioRef.current.pause();
        }
        setPlaying(!playing);
    }

    const progress = duration ? (currentTime / duration) * WeveLength : 0;

    const handleFormatTime = (time) => {
        const minit = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${String(minit).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
    }

    const handleGetWevaHight = () => {
        const Hight = [25, 10, 15, 20, 16, 12, 22];
        const randomIndex = Math.floor(Math.random() * Hight.length);
        return Hight[randomIndex];
    }

    const handlePlayVideo = () => {
        window.open(userdata.video, "_blank");
    }

    const handleSubscribe = async () => {
        if (!Userid) {
            navigate("/auth/login");
            return;
        }

        if (apiloading === "Subscribe") return;
        const Apidata = {
            astrologer_id,
            user_id: Userid,
            status: isSubscribe ? "false" : "true",
        }
        setApiLoading("Subscribe");
        const Response = await HandleCallApi("Post", "user/subscrib-unsubscribe", Apidata)
        setIsToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode == "200") {
            setIsSubscribe(!isSubscribe);
        }
        setApiLoading("");
    }

    const handleSelectGift = (item) => {
        const MyWallet = secureLocalStorage.getItem("userwallet");
        const isDisabled = totalPrice + item.price > MyWallet;

        if (isDisabled) {
            setIsToast(true);
            setToastMsg("Insufficient wallet balance !!");
            return;
        }

        if (selectGift.map((list) => list.id).includes(item.id)) {
            const FilterIds = selectGift.filter(list => list.id !== item.id);
            setSelectGift(FilterIds);
        } else {
            setSelectGift((prev) => [...prev, item]);
        }
    }

    const handleSendGift = async () => {
        if (selectGift.length === 0) {
            setIsToast(true);
            setToastMsg("Please select a gift first!");
            return;
        }
        setApiLoading("Gift");
        const Response = await HandleCallApi("Post", "user/send_gift", { user_id: Userid, astro_id: astrologer_id, gift_id: selectGift.map((item) => item.id).join(",") });
        if (Response && Response.data) {
            setIsToast(true);
            setToastMsg(Response.data.message);
            if (Response.data.ResponseCode === 200) {
                secureLocalStorage.setItem("userwallet", Response.data.user_wallet);
                setUserWallet(Response.data.user_wallet);
                setShowModel("");
                setSelectGift([]);
            }
        }
        setApiLoading("");
    }

    const ShowButSection = (generaldetail?.chat_status == "1" && generaldetail?.chat_status == userdata?.chat_status) || (generaldetail?.audio_call_status == "1" && generaldetail?.audio_call_status == userdata?.audio_call_status) || (generaldetail?.video_call_status == "1" && generaldetail?.video_call_status == userdata?.video_call_status);

    return (
        <div className='astrologer_details'>
            {!loading && (
                <div className="width_container">
                    <div className={`layout_grid ${!ShowButSection ? 'no_widget' : ''}`}>
                        
                        {/* ProfileHeroCard Component */}
                        <ProfileHeroCard 
                            userdata={userdata} 
                            isfollow={isfollow} 
                            apiloading={apiloading} 
                            isSubscribe={isSubscribe}
                            handleSubscribe={handleSubscribe} 
                            handleFollow={handleFollow}
                            setShowModel={setShowModel}
                            Userid={Userid}
                            BaseUrl={BaseUrl}
                            navigate={navigate}
                            t={t}
                        />

                        {/* ConsultationWidget Component (sticky column) */}
                        {ShowButSection && (
                            <ConsultationWidget 
                                userdata={userdata} 
                                generaldetail={generaldetail} 
                                apiloading={apiloading} 
                                handleStartChat={handleStartChat}
                                formatPrice={formatPrice}
                                navigate={navigate}
                                t={t}
                            />
                        )}

                        {/* IntroMediaBar Component */}
                        {(userdata?.audio || userdata?.video) && (
                            <IntroMediaBar 
                                userdata={userdata} 
                                BaseUrl={BaseUrl} 
                                audioRef={audioRef} 
                                playing={playing} 
                                currentTime={currentTime} 
                                duration={duration}
                                showAudioPlay={showAudioPlay}
                                wevaList={wevaList}
                                progress={progress}
                                handlePlayAudio={handlePlayAudio}
                                handlePlayVideo={handlePlayVideo}
                                handleFormatTime={handleFormatTime}
                                setShowAudioPlay={setShowAudioPlay}
                                setCurrentTime={setCurrentTime}
                                setDuration={setDuration}
                                t={t}
                            />
                        )}

                        {/* AstrologerBio Component */}
                        <AstrologerBio 
                            userdata={userdata} 
                            showmore={showmore} 
                            setShowMore={setShowMore}
                            t={t}
                        />

                        {/* ProfileTabs Component (Tab card containing sub-tabs) */}
                        <ProfileTabs 
                            isstep={isstep} 
                            setIsStep={setIsStep} 
                            reviewslist={reviewslist} 
                            postlist={postlist} 
                            faqList={faqList} 
                            userdata={userdata}
                            BaseUrl={BaseUrl}
                            Userid={Userid}
                            handleLikePost={handleLikePost}
                            handleGetComment={handleGetComment}
                            setImgList={setImgList}
                            setImgIndex={setImgIndex}
                            t={t}
                        />

                    </div>
                </div>
            )}

            {ischatpaymodel && (
                <BookApoint 
                    KundliList={kundlilist} 
                    userdata={userdata} 
                    isclickindex={isclickindex} 
                    setIsChatPayModel={setIsChatPayModel} 
                    user_wallet={userwallet} 
                />
            )}

            {iscommentmodel && (
                <div onClick={() => setIsCommentModel(false)} className="model items-end">
                    <div onClick={(e) => e.stopPropagation()} className="comment_box">
                        <div className="flex items-center gap-[10px] pb-4 border-b">
                            <button onClick={() => setIsCommentModel(false)}>
                                <X size={20} color="black" />
                            </button>
                            <h1 className='font-medium text-[18px]'>{t("Comment")}</h1>
                        </div>
                        {apiloading === "Comment" ? (
                            <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                        ) : (
                            <div className="h-full overflow-y-auto pt-4 space-y-4">
                                {commentlist.length >= 1 ? (
                                    commentlist.map((item, index) => (
                                        <div key={index} className="flex items-start justify-between">
                                            <div className="flex items-start gap-[12px]">
                                                <div className="w-[40px] h-[40px]">
                                                    <ImageLoad url={item.profile ? BaseUrl + item.profile : ""} alt={`${item.name} Profile`} CustomeStyle={"w-full h-full rounded-full object-cover"} />
                                                </div>
                                                <div className="leading-5">
                                                    <h1 className='font-medium text-[15px] text-gray-800'>{item.name}</h1>
                                                    <p className='text-[13px] text-gray-500'>{item.date} ago</p>
                                                    <p className='mt-[6px] text-[14px] text-gray-700'>{item.mes}</p>
                                                </div>
                                            </div>
                                            {Userid == item.uid && (
                                                <button onClick={() => setDeleteComId(item.id)} className='text-red-500 hover:opacity-85'>
                                                    <X size={16} />
                                                </button>
                                            )}
                                        </div>
                                    ))
                                ) : (
                                    <div className='h-full flex items-center justify-center py-12'>
                                        <div className="text-center">
                                            <h1 className='font-medium text-[18px]'>{t("No comment yet")}</h1>
                                            <p className='text-[14px] text-gray-500'>{t("start the conversation")}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        <div className="flex items-center gap-[10px] pt-4 border-t mt-auto">
                            <input 
                                type="text" 
                                value={inputcomment} 
                                onChange={(e) => setInputComment(e.target.value)} 
                                placeholder={t('Poast your replay')} 
                                className='w-full border-[1px] focus-within:border-[--bgcolor] outline-none px-[12px] py-[8px] rounded-[10px] text-[14px]' 
                            />
                            <button onClick={handleSendComment} className='bg-[#F97316] text-white rounded-full p-[10px] hover:bg-[#EA6C0A] transition-colors'>
                                <MessageCircle size={18} color="white" />
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {deletecomid && (
                <div onClick={() => setDeleteComId("")} className="model items-center">
                    <div onClick={(e) => e.stopPropagation()} className="w-[300px] bg-white p-[20px] rounded-[15px]">
                        <h1 className='font-medium text-[20px]'>{t("Delete comment")}</h1>
                        <p className='leading-5 mt-[10px] text-gray-600 text-[14px]'>{t("Are you sure you want to delete this comment?")}</p>
                        <div className="flex items-center gap-[10px] mt-[20px]">
                            <button onClick={() => setDeleteComId("")} className='w-full text-blue-500 font-medium border-[1px] border-blue-500 py-[8px] rounded-[10px] text-[14px]'>{t("Cancle")}</button>
                            <button 
                                onClick={() => {
                                    if (commentdata.id.toString().startsWith("sample")) {
                                        handleDeleteSampleComment(deletecomid);
                                    } else {
                                        handleGetComment(commentdata, "2");
                                    }
                                }} 
                                className='w-full text-white bg-red-500 font-medium py-[8px] rounded-[10px] text-[14px]'
                            >
                                {t("Delete")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showModel === "Gift" && (
                <div onClick={() => setShowModel("")} className="model items-center">
                    <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: "450px" }} className="bg-white max-h-[90vh] p-[24px] rounded-[16px] relative mx-[10px] overflow-y-auto">
                        <div className="flex items-center justify-between pb-4 border-b">
                            <div className="flex items-center gap-[10px]">
                                <button onClick={() => setShowModel("")}>
                                    <X size={20} color="black" />
                                </button>
                                <h1 className='font-semibold text-[18px]'>{t("Send Gift")}</h1>
                            </div>
                            <div className="flex items-center gap-2 bg-gray-100 py-[5px] px-[10px] rounded-[50px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="text-white bg-[#F97316] p-[4px] rounded-full" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>
                                <span className='font-medium text-[14px] text-gray-700'>{formatPrice(secureLocalStorage.getItem("userwallet") || 0, 2)}</span>
                            </div>
                        </div>

                        <div className="mt-6">
                            <div className="grid grid-cols-3 gap-[16px]">
                                {giftList.map((item, index) => {
                                    const IsSelected = selectGift.map((list) => list.id).includes(item.id);
                                    return (
                                        <div 
                                            key={index} 
                                            onClick={() => handleSelectGift(item)} 
                                            className={`border ${IsSelected ? "border-[#F97316] bg-orange-50/50" : "border-gray-200"} p-[12px] rounded-[12px] relative text-center cursor-pointer hover:border-[#F97316] transition-colors`}
                                        >
                                            {IsSelected && (
                                                <div className="absolute -top-[6px] -right-[6px] bg-[#F97316] p-[4px] rounded-full">
                                                    <Check size={8} color="white" strokeWidth={3} />
                                                </div>
                                            )}
                                            <ImageLoad url={BaseUrl + item.image} CustomeStyle={"w-full h-[50px] object-contain mb-2 rounded-[10px]"} alt={"Gift"} />
                                            <span className="text-[14px] font-semibold text-gray-800">{formatPrice(item.price)}</span> <br />
                                            <p className="text-[12px] text-gray-500 truncate">{item.title}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <button onClick={handleSendGift} className="w-full btn_primary mt-6">
                            {apiloading === "Gift" ? <Btn_loader CustomeStyle={"bg-white"} /> : t("Send Gift")}
                        </button>
                    </div>
                </div>
            )}

            <PageLoading loading={loading} />
            {imgList && <ImagePrev imgList={imgList} index={imgIndex} setImgList={setImgList} />}
        </div>
    );
}

export default Astrologers_details;

/* =========================================================================
   SUB-COMPONENTS (Cleanly scoped, inheriting parent handlers & contexts)
   ========================================================================= */

/* LEFT COLUMN — SECTION 1: Profile Hero Card */
const ProfileHeroCard = ({ userdata, isfollow, apiloading, isSubscribe, handleSubscribe, handleFollow, setShowModel, Userid, BaseUrl, navigate, t }) => {
    return (
        <div className="hero_card premium_card">
            
            {/* Subscription/Notification bell trigger on top-right */}
            <button onClick={handleSubscribe} className="bell_button" aria-label="Subscribe notifications">
                {isSubscribe ? <Bell size={18} fill="#6B7280" /> : <Bell size={18} />}
            </button>

            {/* Avatar & Horizontal Stats Block */}
            <div className="hero_top_row">
                <div className="avatar_wrapper">
                    <div className="pulse_ring"></div>
                    <ImageLoad 
                        url={BaseUrl + userdata?.image} 
                        CustomeStyle="avatar_img" 
                        alt={`${userdata.name || 'avatar'}`} 
                    />
                </div>

                <div className="stats_wrapper">
                    <div className="stat_item">
                        <div className="stat_number">{userdata?.torder || 41}</div>
                        <div className="stat_label">{t("Orders")}</div>
                    </div>
                    <div className="stat_divider"></div>
                    <div className="stat_item">
                        <div className="stat_number">{userdata?.experience ? `${userdata.experience} Yr` : "19 Yr"}</div>
                        <div className="stat_label">{t("Experience")}</div>
                    </div>
                    <div className="stat_divider"></div>
                    <div className="stat_item">
                        <div className="stat_number">{userdata?.rating || 32}</div>
                        <div className="stat_label">{t("Rating")}</div>
                    </div>
                </div>
            </div>

            {/* Name, Verified Badge & Specialization Details */}
            <div className="profile_info">
                <div className="name_row">
                    <h1 className="astrologer_name">{userdata?.name || "Acharya Shastri"}</h1>
                    {userdata?.vstatus === 1 && (
                        <div className="verified_badge">
                            <Check size={12} strokeWidth={3} />
                            <span>{t("Verified")}</span>
                        </div>
                    )}
                </div>

                <div className="info_rows">
                    <div className="info_row">
                        <Compass size={16} className="info_icon" />
                        <span>{userdata?.skills || "Life Coach, Nadi, Tarot"}</span>
                    </div>
                    <div className="info_row">
                        <Globe size={16} className="info_icon" />
                        <span>{userdata?.lang || "Bhojpuri, Hindi"}</span>
                    </div>
                    <div className="info_row">
                        <GraduationCap size={16} className="info_icon" />
                        <span>Exp: {userdata?.experience || 19} Years</span>
                    </div>
                </div>
            </div>

            {/* Left Column actions buttons */}
            <div className="action_buttons">
                <button 
                    disabled={apiloading === "follow"} 
                    onClick={handleFollow}
                    className="btn_primary w-full"
                >
                    {apiloading === "follow" ? (
                        <Btn_loader CustomeStyle="bg-white" />
                    ) : isfollow === 1 ? (
                        t("Unfollow")
                    ) : (
                        t("Follow")
                    )}
                </button>

                {secureLocalStorage.getItem("isgift") == "1" && (
                    <button 
                        onClick={() => Userid ? setShowModel("Gift") : navigate("/auth/login")} 
                        className="btn_black w-full"
                    >
                        {t("Send Gift")}
                    </button>
                )}
            </div>
        </div>
    );
};
/* RIGHT COLUMN — Consultation Widget Card (Sticky widget) */
const ConsultationWidget = ({ userdata, generaldetail, apiloading, handleStartChat, formatPrice, navigate, t }) => {
    const isNewUser = generaldetail?.free_minit === "1";

    const getFreeMinutes = (astroMin, defaultMin) => {
        const aMin = parseFloat(astroMin);
        const dMin = parseFloat(defaultMin);
        if (!isNaN(aMin) && aMin > 0) return aMin;
        if (!isNaN(dMin) && dMin > 0) return dMin;
        return 2; // global fallback
    };

    const chatFreeMin = getFreeMinutes(userdata?.chat_free_minute, generaldetail?.free_chat_minute);
    const audioFreeMin = getFreeMinutes(userdata?.audio_free_minute, generaldetail?.free_audio_call_minute);
    const videoFreeMin = getFreeMinutes(userdata?.video_free_minute, generaldetail?.free_video_call_minute);

    return (
        <div className="consultation_widget premium_card">
            <h2 className="widget_title">{t("Start a Consultation")}</h2>
            <div className="consultation_buttons">
                
                {/* Button 1: Chat */}
                {(generaldetail?.chat_status == "1" && generaldetail?.chat_status == userdata?.chat_status) && (
                    <button 
                        disabled={!!apiloading} 
                        onClick={() => handleStartChat("ButtonChat", 1)} 
                        className="consult_btn"
                    >
                        <div className="consult_icon_circle">
                            <MessageCircle size={18} color="white" />
                        </div>
                        <div className="consult_info">
                            <span className="consult_label">{t("Chat with astrologer")}</span>
                            <div className="flex items-center gap-2 mt-[2px] flex-wrap">
                                {isNewUser && (
                                    <span className="new_user_badge">{t("For new user")} {chatFreeMin} {t("min free")}</span>
                                )}
                                <span className="consult_price">{formatPrice(userdata?.chat_off_price || 10)}/min</span>
                            </div>
                        </div>
                    </button>
                )}

                {/* Button 2: Call */}
                {(generaldetail?.audio_call_status == "1" && generaldetail?.audio_call_status == userdata?.audio_call_status) && (
                    <button 
                        disabled={!!apiloading} 
                        onClick={() => handleStartChat("ButtonCall", 2)} 
                        className="consult_btn"
                    >
                        <div className="consult_icon_circle">
                            <Phone size={18} color="white" />
                        </div>
                        <div className="consult_info">
                            <span className="consult_label">{t("Call with astrologer")}</span>
                            <div className="flex items-center gap-2 mt-[2px] flex-wrap">
                                {isNewUser && (
                                    <span className="new_user_badge">{t("For new user")} {audioFreeMin} {t("min free")}</span>
                                )}
                                <span className="consult_price">{formatPrice(userdata?.audio_offer_price || 15)}/min</span>
                            </div>
                        </div>
                    </button>
                )}

                {/* Button 3: Video Call */}
                {(generaldetail?.video_call_status == "1" && generaldetail?.video_call_status == userdata?.video_call_status) && (
                    <button 
                        disabled={!!apiloading} 
                        onClick={() => handleStartChat("ButtonVideo", 3)} 
                        className="consult_btn"
                    >
                        <div className="consult_icon_circle">
                            <Video size={18} color="white" />
                        </div>
                        <div className="consult_info">
                            <span className="consult_label">{t("Video call with astrologer")}</span>
                            <div className="flex items-center gap-2 mt-[2px] flex-wrap">
                                {isNewUser && (
                                    <span className="new_user_badge">{t("For new user")} {videoFreeMin} {t("min free")}</span>
                                )}
                                <span className="consult_price">{formatPrice(userdata?.video_offer_price || 20)}/min</span>
                            </div>
                        </div>
                    </button>
                )}

                {/* Button 4: Astrologer AI Assistant */}
                {secureLocalStorage.getItem("aishow") === "true" && (
                    <button 
                        onClick={() => navigate("/astrologer-ai")} 
                        className="consult_btn"
                    >
                      <div className="consult_icon_circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-white">
                          <path d="M12 8V4H8" />
                          <rect width="16" height="12" x="4" y="8" rx="2" />
                          <path d="M2 14h2" />
                          <path d="M20 14h2" />
                          <path d="M15 13v2" />
                          <path d="M9 13v2" />
                        </svg>
                      </div>
                      <div className="consult_info text-start">
                        <span className="consult_label flex items-center gap-1.5">
                          {t("Astrologer AI Chat")}
                          <span className="bg-white text-[#F97316] text-[9px] font-extrabold px-1.5 py-0.5 rounded-full uppercase tracking-wider">{t("AI")}</span>
                        </span>
                        <p className="text-[11px] text-white/80 mt-[2px]">{t("Ask instant horoscopes & predictions")}</p>
                      </div>
                    </button>
                )}
            </div>
            
            {/* Secure & Confidential Badge */}
            <div className="trust_row">
                <Lock size={14} className="trust_icon" />
                <span>{t("Secure & Confidential")}</span>
            </div>
        </div>
    );
};


/* LEFT COLUMN — SECTION 2: Intro Media Bar Card */
const IntroMediaBar = ({ userdata, BaseUrl, audioRef, playing, currentTime, duration, showAudioPlay, wevaList, progress, handlePlayAudio, handlePlayVideo, handleFormatTime, setShowAudioPlay, setCurrentTime, setDuration, t }) => {
    return (
        <div className="media_bar premium_card">
            
            <div className="flex items-center justify-between w-full">
                {/* Audio Hear Prompt */}
                <div className="media_prompt">
                    <Music size={20} className="media_prompt_icon" />
                    <span className="font-semibold text-[15px] text-gray-800">{t("Hear from")} {userdata?.name || "Acharya Shastri"}</span>
                </div>

                {/* Triggers buttons */}
                <div className="media_buttons">
                    {userdata?.audio && (
                        <button 
                            onClick={() => { setShowAudioPlay(true); handlePlayAudio(); }} 
                            className="btn_black btn_pill"
                        >
                            {t("Intro Audio")}
                        </button>
                    )}
                    {userdata?.video && (
                        <button 
                            onClick={handlePlayVideo} 
                            className="btn_black btn_pill"
                        >
                            {t("Intro Video")}
                        </button>
                    )}
                </div>
            </div>

            <audio 
                ref={audioRef} 
                src={BaseUrl + userdata?.audio} 
                onTimeUpdate={(e) => setCurrentTime(e.target.currentTime)}
                onLoadedMetadata={(e) => setDuration(e.target.duration)}
            />

            {/* Dedicated full-width Waveform audio player */}
            {showAudioPlay && (
                <div className="w-full bg-gray-50 border border-gray-200/60 p-4 rounded-xl flex items-center justify-between gap-4 mt-2">
                    <button 
                        onClick={handlePlayAudio} 
                        className="w-10 h-10 bg-[#F97316] rounded-full flex items-center justify-center hover:bg-[#EA6C0A] transition-colors shadow-md flex-shrink-0"
                    >
                        {playing ? <Pause size={16} color="white" /> : <Play size={16} color="white" />}
                    </button>
                    
                    <div className="waveform_container flex items-center gap-[4px] flex-grow justify-center px-4">
                        {Array.isArray(wevaList) && wevaList.map((item, index) => (
                            <div 
                                key={index} 
                                style={{ height: `${item}px` }} 
                                className={`w-[4px] ${progress > index ? "bg-[#F97316]" : "bg-gray-300"} rounded-full transition-all`}
                            ></div>
                        ))}
                    </div>

                    <span className="text-[13px] font-bold text-gray-600 min-w-[38px] text-right">
                        {handleFormatTime(currentTime)}
                    </span>

                    <button 
                        onClick={() => { setShowAudioPlay(false); playing && handlePlayAudio(); }} 
                        className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors flex-shrink-0"
                    >
                        <X size={16} color="black" />
                    </button>
                </div>
            )}
        </div>
    );
};

/* LEFT COLUMN — SECTION 3: Astrologer Bio Card */
const AstrologerBio = ({ userdata, showmore, setShowMore, t }) => {
    return (
        <div className="bio_card premium_card">
            <h2 className="bio_heading">{t("Astrologer Bio")}</h2>
            <p className="bio_text">
                {userdata?.description?.length > 410 ? (
                    showmore ? userdata.description : `${userdata.description.slice(0, 410)}...`
                ) : (
                    userdata?.description || "With 19 years of dedicated experience in astrology, Acharya Shastri is specialized in Vedic interpretations, palmistry, and Nadi reading. Over the years, they have helped thousands of clients overcome issues regarding career choices, relationship compatibility, health, and financial growth. Committed to providing precise guidance and practical remedies."
                )}
                {userdata?.description?.length > 410 && (
                    <button 
                        onClick={() => setShowMore(!showmore)} 
                        className="bio_more_btn"
                    >
                        {showmore ? t("Show Less") : t("Show More")}
                    </button>
                )}
            </p>
        </div>
    );
};

/* LEFT COLUMN — SECTION 4: Tabs Card (Manages internal states) */
const ProfileTabs = ({ isstep, setIsStep, reviewslist, postlist, faqList, userdata, BaseUrl, Userid, handleLikePost, handleGetComment, setImgList, setImgIndex, t }) => {
    return (
        <div className="tabs_card premium_card">
            
            {/* Tab switch buttons block */}
            <div className="tabs_header_container">
                <div className="tab_triggers">
                    <button onClick={() => setIsStep(1)} className={`tab_trigger ${isstep === 1 ? 'active' : ''}`}>
                        <Star size={16} />
                        <span>{t("Reviews")}</span>
                    </button>
                    <button onClick={() => setIsStep(2)} className={`tab_trigger ${isstep === 2 ? 'active' : ''}`}>
                        <Activity size={16} />
                        <span>{t("Activity")}</span>
                    </button>
                    <button onClick={() => setIsStep(3)} className={`tab_trigger ${isstep === 3 ? 'active' : ''}`}>
                        <HelpCircle size={16} />
                        <span>{t("FAQ's")}</span>
                    </button>
                    <button onClick={() => setIsStep(4)} className={`tab_trigger ${isstep === 4 ? 'active' : ''}`}>
                        <ImageIcon size={16} />
                        <span>{t("Media")}</span>
                    </button>
                    
                    {/* Active sliding underline */}
                    <div className={`tab_underline underline_step_${isstep - 1}`}></div>
                </div>
            </div>

            {/* Render Tab Contents */}
            <div className="tab_contents_wrapper">
                
                {/* 1. Reviews Tab */}
                {isstep === 1 && (
                    <div className="tab_pane">
                        {reviewslist.map((item, index) => (
                            <motion.div 
                                key={index}
                                initial={{ opacity: 0, y: 15 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.2, delay: index * 0.05 }}
                                className="review_card"
                            >
                                <div className="review_header">
                                    <ImageLoad 
                                        url={item.profile ? BaseUrl + item.profile : ""} 
                                        CustomeStyle="reviewer_avatar" 
                                        alt="Reviewer" 
                                    />
                                    <div>
                                        <h4 className="reviewer_name">{item.name}</h4>
                                        <div className="rating_row">
                                            {Array.from({ length: 5 }).map((_, i) => (
                                                <svg 
                                                    key={i} 
                                                    width="16" 
                                                    height="16" 
                                                    viewBox="0 0 24 24" 
                                                    fill={i < Math.floor(item.tot_star) ? "#F59E0B" : "none"} 
                                                    stroke="#F59E0B"
                                                    strokeWidth={2}
                                                >
                                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                                </svg>
                                            ))}
                                            <span className="rating_number">{item.tot_star}</span>
                                        </div>
                                    </div>
                                </div>
                                <p className="review_text">{item.review}</p>
                            </motion.div>
                        ))}
                    </div>
                )}

                {/* 2. Activity Tab */}
                {isstep === 2 && (
                    <div className="tab_pane space-y-4">
                        {postlist.map((item, index) => (
                            <motion.div 
                                key={index}
                                initial={{ opacity: 0, y: 15 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.2, delay: index * 0.05 }}
                                className="post_card"
                            >
                                <div className="post_header">
                                    <ImageLoad 
                                        url={item.pimage ? BaseUrl + item.pimage : ""} 
                                        CustomeStyle="post_avatar" 
                                        alt="Astro Avatar" 
                                    />
                                    <div className="post_meta">
                                        <span className="post_author">{item.name || "Acharya Shastri"}</span>
                                        <span className="post_time">{item.date} ago</span>
                                    </div>
                                </div>

                                <p className="post_text">{item.text}</p>
                                
                                {item.media && item.media.length >= 1 && (
                                    <div className="mt-3">
                                        <Swiper slidesPerView={'auto'} spaceBetween={10} pagination={{ clickable: true }} modules={[Pagination]}>
                                            {item.media.map((image, idx) => (
                                                <SwiperSlide key={idx} onClick={() => { setImgList(item.media); setImgIndex(idx); }} style={{ width: "150px" }} className="cursor-pointer">
                                                    <ImageLoad url={BaseUrl + image} CustomeStyle="post_media_thumbnail" alt="media" />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                )}

                                <div className="post_actions">
                                    <button 
                                        onClick={() => handleLikePost(item, item.IsLike)} 
                                        className={`post_action_btn ${item.IsLike === 1 ? 'heart_active' : ''}`}
                                    >
                                        <Heart size={16} fill={item.IsLike === 1 ? "#EF4444" : "none"} />
                                        <span>{item.tlikes || 0}</span>
                                    </button>

                                    <button 
                                        onClick={() => handleGetComment(item, "0")} 
                                        className="post_action_btn"
                                    >
                                        <MessageCircle size={16} />
                                        <span>{item.tcomments || 0}</span>
                                    </button>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                )}

                {/* 3. FAQ's Tab */}
                {isstep === 3 && (
                    <div className="tab_pane">
                        {faqList.map((item, index) => (
                            <motion.div 
                                key={index}
                                initial={{ opacity: 0, y: 15 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.2, delay: index * 0.05 }}
                            >
                                <FAQItem faq={item} index={index} />
                            </motion.div>
                        ))}
                    </div>
                )}

                {/* 4. Media Tab */}
                {isstep === 4 && (
                    <div className="tab_pane">
                        {userdata?.gallery_images && userdata.gallery_images.length >= 1 ? (
                            <div className="media_grid">
                                {userdata.gallery_images.map((item, index) => (
                                    <div 
                                        key={index} 
                                        onClick={() => { setImgList(userdata.gallery_images); setImgIndex(index); }} 
                                        className="media_placeholder"
                                    >
                                        <ImageLoad url={BaseUrl + item} CustomeStyle={"w-full h-full object-cover rounded-[12px]"} alt="media" />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="media_grid">
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <div 
                                        key={index} 
                                        className="media_placeholder"
                                    ></div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

            </div>
        </div>
    );
};

/* FAQItem accordion helper sub-component (Uses local state for toggling) */
const FAQItem = ({ faq, index }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="faq_card">
            <button className="faq_trigger" onClick={() => setIsOpen(!isOpen)}>
                <span className="faq_question">{index + 1}. {faq.title}</span>
                {isOpen ? <X className="faq_icon" size={20} /> : <Plus className="faq_icon" size={20} />}
            </button>
            <div 
                className="faq_content" 
                style={{ 
                    maxHeight: isOpen ? "1000px" : "0px",
                    transition: "max-height 0.3s ease-in-out"
                }}
            >
                <div className="faq_answer" dangerouslySetInnerHTML={{ __html: faq.description }} />
            </div>
        </div>
    );
};